module.exports = __webpack_public_path__ + "img/bochum.85859094.png";